import { render } from "./Placing.vue?vue&type=template&id=9d20fae2"
import script from "./Placing.vue?vue&type=script&lang=ts"
export * from "./Placing.vue?vue&type=script&lang=ts"
script.render = render

export default script